import { render, staticRenderFns } from "./index.vue?vue&type=template&id=197113b8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=197113b8&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197113b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197113b8')) {
      api.createRecord('197113b8', component.options)
    } else {
      api.reload('197113b8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=197113b8&scoped=true", function () {
      api.rerender('197113b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/connersParentScale/connersQrcode/index.vue"
export default component.exports